module.exports = __webpack_public_path__ + "static/media/a23.bcba9869.pdf";